module.exports = __webpack_public_path__ + "static/media/onestack-meta.0e7059bd.png";